import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { isAuthenticated, logout } from '../services/authService';
import { canAccessRoute, denyRouteAccess, isPublicPath } from '../services/routeGuardService';

export function ProtectedRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        const { pathname } = props.location;

        if (isPublicPath(pathname)) {
          return <Component {...props} />;
        }

        if (!isAuthenticated()) {
          logout();
          return <Redirect to="/" />;
        }

        if (!canAccessRoute(pathname)) {
          denyRouteAccess();
          return <Redirect to="/" />;
        }

        return <Component {...props} />;
      }}
    />
  );
}
